import { API_PATHS } from "../../../config/ApiPaths";
import { POST_DATA_HALOTEL, TYPE_HALOTEL_REVENUE } from "./type";

export const getDataRevenueHalotel = (url) => {
  return {
    type: TYPE_HALOTEL_REVENUE,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const postDataRevenueHalotel = (data) => {
  return {
    type: POST_DATA_HALOTEL,
    meta: {
      querry: data,
      url: API_PATHS.postHalotel,
      method: "POST",
    },
  };
};
